export default [
	{
		path: '/content/:action(share)?/:actionContentId(\\d+)?',
		name: 'Content',
		component: () => import('@/views/content/Content.vue'),
		props: true,
		meta: {
			layout: 'Default',
			abilities: [
                ['view', 'workspace-content'],
                ['view', 'ugc-content'],
              ],
            nav: 'content',
		}
	},
	{
		path: '/content/filterBy/:filterBy/:filterValue',
		name: 'Content With Filter',
		component: () => import('@/views/content/Content.vue'),
		meta: {
			layout: 'Default',
			abilities: [
                ['view', 'workspace-content'],
                ['view', 'ugc-content'],
              ],
            nav: 'content',
		}
	},
	{
		path: '/content/:id(\\d+)',
		name: 'Content Details',
		component: () => import('@/views/content/ContentDetails.vue'),
		meta: {
			layout: 'Default',
			abilities: [
				['view', 'workspace-content'],
				['view', 'ugc-content'],
			],
            nav: 'content',
		}
	},
	{
		path: '/content/:id(\\d+)/:tab',
		name: 'Content Details Tab',
		component: () => import('@/views/content/ContentDetails.vue'),
		meta: {
			layout: 'Default',
			abilities: [
				['view', 'workspace-content'],
				['view', 'ugc-content'],
			],
            nav: 'content',
		}
	},
	{
		path: '/content/onboarding',
		name: 'Content Management Onboarding',
		component: () => import('@/views/content/ContentManagementOnboarding.vue'),
		meta: {
			layout: 'Default',
			abilities: [
                ['view', 'workspace-content'],
                ['view', 'ugc-content'],
              ],
            nav: 'content',
		}
	}
]